import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_AUTH_URL,
  realm: process.env.REACT_APP_AUTH_REALM_NAME,
  clientId: process.env.REACT_APP_CLIENT_ID,
});

export default keycloak;
